export default __webpack_public_path__ + "static/media/steam_marketplace.22a0acf9.png";